var _rect, _rect2, _path, _path2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_239_33641",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_239_33641)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.7333C14.2091 11.7333 16 10.0619 16 8C16 5.93813 14.2091 4.26666 12 4.26666C9.79086 4.26666 8 5.93813 8 8C8 10.0619 9.79086 11.7333 12 11.7333Z",
    fill: "#E01B41"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_239_33641",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 4,
    width: 8,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.7333C14.2091 11.7333 16 10.0619 16 8C16 5.93813 14.2091 4.26666 12 4.26666C9.79086 4.26666 8 5.93813 8 8C8 10.0619 9.79086 11.7333 12 11.7333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_239_33641)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00012 8.53331C9.14298 9.53331 10.8573 10.1333 12.0001 8.53331C13.143 6.93331 15.4287 6.93331 16.0001 8.53331C16.5716 10.1333 16.0001 11.7333 16.0001 11.7333H8.00012C8.00012 11.7333 6.85727 7.53331 8.00012 8.53331Z",
    fill: "#0E4B9C"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8696 2.98959C17.7076 3.07692 17.6547 3.27463 17.7515 3.43119L19.1151 5.63551C19.212 5.79207 19.4218 5.8482 19.5839 5.76087L19.9868 5.54378C20.1488 5.45645 20.2017 5.25874 20.1049 5.10218L18.7413 2.89786C18.6444 2.74129 18.4346 2.68517 18.2725 2.7725L17.8696 2.98959ZM16.385 3.78958C16.223 3.87691 16.1701 4.07463 16.2669 4.23119L17.6305 6.43551C17.7273 6.59207 17.9372 6.64819 18.0993 6.56087L18.5022 6.34378C18.6642 6.25645 18.7171 6.05874 18.6202 5.90218L17.2567 3.69785C17.1598 3.54129 16.9499 3.48517 16.7879 3.5725L16.385 3.78958ZM3.89514 10.8979C3.79829 10.7413 3.85116 10.5436 4.01322 10.4563L4.41608 10.2392C4.57814 10.1518 4.78803 10.208 4.88488 10.3645L6.24845 12.5688C6.3453 12.7254 6.29243 12.9231 6.13037 13.0105L5.7275 13.2275C5.56544 13.3149 5.35555 13.2587 5.25871 13.1022L3.89514 10.8979ZM5.49783 9.65625C5.33577 9.74358 5.2829 9.9413 5.37975 10.0979L6.74332 12.3022C6.84017 12.4587 7.05006 12.5149 7.21212 12.4275L7.61498 12.2105C7.77704 12.1231 7.82991 11.9254 7.73306 11.7688L6.36949 9.56452C6.27265 9.40796 6.06276 9.35184 5.90069 9.43917L5.49783 9.65625ZM17.6305 9.56453C17.7273 9.40796 17.9372 9.35184 18.0993 9.43917L18.5022 9.65626C18.6642 9.74359 18.7171 9.9413 18.6202 10.0979L17.2567 12.3022C17.1598 12.4587 16.9499 12.5149 16.7879 12.4275L16.385 12.2105C16.2229 12.1231 16.1701 11.9254 16.2669 11.7688L17.6305 9.56453ZM19.5839 10.2392C19.4218 10.1518 19.212 10.208 19.1151 10.3645L17.7515 12.5688C17.6547 12.7254 17.7076 12.9231 17.8696 13.0105L18.2725 13.2275C18.4345 13.3149 18.6444 13.2587 18.7413 13.1022L20.1049 10.8979C20.2017 10.7413 20.1488 10.5436 19.9868 10.4563L19.5839 10.2392ZM5.25871 2.89786C5.35555 2.7413 5.56544 2.68517 5.72751 2.7725L6.13037 2.98959C6.29243 3.07692 6.3453 3.27463 6.24845 3.43119L4.88488 5.63551C4.78803 5.79207 4.57814 5.8482 4.41608 5.76087L4.01322 5.54378C3.85116 5.45645 3.79829 5.25874 3.89514 5.10218L5.25871 2.89786ZM7.21212 3.5725C7.05006 3.48517 6.84017 3.5413 6.74332 3.69786L5.37975 5.90218C5.2829 6.05874 5.33577 6.25646 5.49783 6.34379L5.90069 6.56087C6.06276 6.6482 6.27265 6.59208 6.36949 6.43551L7.73306 4.23119C7.82991 4.07463 7.77704 3.87692 7.61498 3.78959L7.21212 3.5725Z",
    fill: "#262626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/KR.4b3b14211f1db994d3be85cf0ee755ff.svg";
export { ForwardRef as ReactComponent };